// Languages a profile can be written in. Keep in sync with
// models/profileLanguages.js on the backend.
export const PROFILE_LANGUAGES = ["en", "sv"];

// Language names are shown in the app UI, which is in English.
const PROFILE_LANGUAGE_NAMES = {
  en: "English",
  sv: "Swedish",
};

export const getProfileLanguageName = (language) =>
  PROFILE_LANGUAGE_NAMES[language] || language;
